const breakpoints = ['960px']

export const theme = {
  breakpoints, 
}
